'use client'
import { useClientAsyncInit, StatsigProvider, StatsigUser } from '@statsig/react-bindings'
import { PropsWithChildren } from 'react'

import { STATSIG_CLIENT_SDK_KEY } from '@src/config/env'

import { useStatsigConsentSync } from './statsig-consent.hook'
import { getStatsigOptions } from './statsig-provider.utils'
import { StatsigUserAwareProvider } from './statsig-user-aware'
import { StatsigExperimentBucket } from './statsig.types'

const NoServerSideExperiments: StatsigExperimentBucket[] = []

export function StatsigBrowserProvider({
  children,
  statsigUser,
  pageOptions,
}: PropsWithChildren<{
  statsigUser: StatsigUser
  pageOptions: {
    pageType: string | undefined
  }
}>) {
  const { client } = useClientAsyncInit(STATSIG_CLIENT_SDK_KEY, statsigUser, getStatsigOptions())
  useStatsigConsentSync(client, statsigUser)

  return (
    <StatsigProvider client={client}>
      <StatsigUserAwareProvider serverSideExperiments={NoServerSideExperiments} pageOptions={pageOptions}>
        {children}
      </StatsigUserAwareProvider>
    </StatsigProvider>
  )
}
